/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import Layout from '../components/Layout';
import { styled } from '../stitches.config';
import { Button, Dialog } from '@mui/material';

interface ImageProps {
    src: string;
    alt: string;
    setFullsizeProps: (props: ImageProps) => void;
}

const StyledThumbnail = styled('img', {
    maxWidth: '200px',
    maxHeight: '200px',
    cursor: 'pointer',
});

const StyledFullsize = styled('img', {
    maxWidth: '100%',
    maxHeight: '100%',
    backgroundColor: 'black',
});

const Thumbnail = (props: ImageProps) => {
    return (
        <StyledThumbnail
            onClick={() => {
                props.setFullsizeProps(props);
            }}
            {...props}
        />
    );
};

const Fullsize = (props: Omit<ImageProps, 'setFullsizeProps'>) => {
    return <StyledFullsize {...props} />;
};

export const Design = () => {
    const [isOpen, setIsOpen] = React.useState(false);
    const [fullsizeProps, setFullsizeProps] = React.useState({} as ImageProps);
    const handleOpen = (props: ImageProps) => {
        setIsOpen(true);
        setFullsizeProps(props);
    };
    return (
        <Layout>
            <div>
                <h1>Design</h1>
                <p>
                    While I dedicate myself to painting first and foremost,
                    design plays a large role in my work as I often make logos
                    and stickers for each piece and create all my own marketing
                    materials. In my day job, I work as a software engineer and
                    have designed several websites and applications, including
                    this one.
                </p>
                <div>
                    <h2>Logos</h2>
                    <div>
                        <Thumbnail
                            src="/images/design/zig-zag-zen.png"
                            alt="Zig Zag Zen Logo"
                            setFullsizeProps={handleOpen}
                        />
                        <Thumbnail
                            src="/images/design/mystery-babylon.png"
                            alt="Mystery Babylon Logo"
                            setFullsizeProps={handleOpen}
                        />
                        <Thumbnail
                            src="/images/design/blazing-june-logo.png"
                            alt="Blazing June Logo"
                            setFullsizeProps={handleOpen}
                        />
                    </div>
                </div>
                <div>
                    <h2>Stickers</h2>
                    <Thumbnail
                        src="/images/stickers.jpeg"
                        alt="Bicycle Day Stickers"
                        setFullsizeProps={handleOpen}
                    />
                </div>
            </div>
            <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
                <Fullsize {...fullsizeProps} />
                <Button onClick={() => setIsOpen(false)}>Close</Button>
            </Dialog>
        </Layout>
    );
};

export default Design;
